export const supportConfig = {
  crispId: "", // Your Crisp ID
};
